import gql from 'graphql-tag';

export default gql`
  query GetRetailerTheme(
    $retailerMoniker: String!
    $versionName: String!
    $localeLanguage: Language
    $localeCountry: Country
    $bannerName: String
    $featureName: String
    $cache: Boolean
    $type: String
  ) {
    retailerTheme(
      product: "narvarjs"
      retailerMoniker: $retailerMoniker
      versionName: $versionName
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
      bannerName: $bannerName
      featureName: $featureName
      cache: $cache
      type: $type
    ) {
      alertNoneNone
      assetpanelcontainerNoneNone
      bodytextDefaultNone
      bodytextEmphasisNone
      buttonsDismissNone
      buttonsPrimaryDefault
      buttonsPrimaryDisabled
      buttonsPrimaryHover
      buttonsSecondaryDefault
      buttonsSecondaryDisabled
      buttonsSecondaryHover
      calendarInputDefault
      calendarInputDisabled
      calendarInputSelected
      calendarStaticDefault
      calendarStaticSelected
      captiontextDefaultNone
      captiontextErrorNone
      chatbubbleImageNone
      chatbubbleMeNone
      chatbubbleThemNone
      dividerPrimaryNone
      documentbodyNoneNone
      floatingpillNoneNone
      footertextNoneNone
      gradientNoneNone
      headersBigNone
      headersHugeNone
      headersMediumNone
      headersSemibigNone
      headersSmallNone
      iconsFooterNone
      iconsPrimaryNone
      iconsSecondaryNone
      imgPrimaryNone
      inputcheckboxesNoneDefault
      inputcheckboxesNoneSelected
      inputlabelNoneDisabled
      inputlabelNoneNone
      inputratingstarsNoneDefault
      inputratingstarsNoneSelected
      inputtextareasNoneDisabled
      inputtextareasNoneFocus
      inputtextareasNoneNone
      inputtextinputsNoneDisabled
      inputtextinputsNoneError
      inputtextinputsNoneFocus
      inputtextinputsNoneNone
      linksLegalDefault
      linksLegalHover
      linksNoneDefault
      linksNoneHover
      linksNoneVisited
      linksTrackingDefault
      linksTrackingHover
      narvarfooterNoneNone
      panelbodyNoneNone
      panelcontainerNoneNone
      panelfooterNoneNone
      panelheaderNoneNone
      productrecspanelcontainerNoneNone
      productrecsarrowcontainerNextNone
      productrecsarrowcontainerPrevNone
      productrecsarrowNoneDefault
      productrecsarrowNoneDisabled
      productrecsarrowNoneHover
      productrecscarouseltitleNoneNone
      productrecsdotcontainerNoneNone
      productrecsdotNoneActive
      productrecsdotNoneDefault
      productrecsdotNoneHover
      productrecsreccontainerNoneNone
      productrecsrecimageNoneNone
      productrecsrecpriceCentsNone
      productrecsrecpriceNoneNone
      productrecsrecpriceOldNone
      productrecsrecpricePriceNone
      productrecsrecpriceSaleNone
      productrecsrecpriceStrikethroughcentsNone
      productrecsrecpriceUsdNone
      productrecsrecratingcontainerNoneNone
      productrecsrecratingstarEmptyNone
      productrecsrecratingstarFullNone
      productrecsrectextBrandNone
      productrecsrectextNameNone
      productrecsrectextNoneNone
      productrecsrectextReviewsNone
      productrecsrectextStaticNone
      productrecsrectextStrikethroughNone
      progressbarmarkerDeliveredDefault
      progressbarmarkerEddDefault
      progressbarmarkerShippedAfter
      progressbarmarkerShippedBefore
      sectiondividerPrimaryNone
      smalltextDefaultNone
      smalltextEmphasisNone
      spinnerPrimaryNone
      telephoneinputNoneNone
    }
  }
`;
